module.exports = __webpack_public_path__ + "static/media/email-sent-icon.390cea0a.svg";